module.exports = __webpack_public_path__ + "img/78.74ca3aa.jpg";